if (!customElements.get('pi-product-card-slider')) {
  customElements.define(
    'pi-product-card-slider',
    class PIProductCardSlider extends HTMLElement {

      constructor() {
        super();
        this.sliderInstance = false;
      }

      connectedCallback() {
        this.initSlider();
      }

      disconnectedCallback() {
        this.destroySlider();
      }

      initSlider() {

        if (this.sliderInstance) {
          return;
        }

        const swiper = this.querySelector(
          '[data-product-card-slider]'
        );

        if (!swiper) {
          return;
        }

        const wrapper = swiper.querySelector(
          '.swiper-wrapper'
        );

        const slides = wrapper
          ? wrapper.querySelectorAll('.swiper-slide')
          : [];

        if (!wrapper || !slides.length) {
          return;
        }

        if (
          !window.FoxTheme ||
          !window.FoxTheme.Carousel
        ) {
          return;
        }

        const pagination = this.querySelector(
          '.pi-product-card-slider__pagination'
        );

        const prevButton = this.querySelector(
          '[data-product-card-slider-prev]'
        );

        const nextButton = this.querySelector(
          '[data-product-card-slider-next]'
        );

        const sliderOptions = {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
          loop: false,
          watchOverflow: true,
          allowTouchMove: true,
          grabCursor: true,
          threshold: 2,

          pagination: pagination
            ? {
                el: pagination,
                type: 'bullets',
                clickable: true
              }
            : undefined,

          navigation:
            prevButton && nextButton
              ? {
                  prevEl: prevButton,
                  nextEl: nextButton
                }
              : undefined
        };

        this.sliderInstance =
          new window.FoxTheme.Carousel(
            swiper,
            sliderOptions
          );

        this.sliderInstance.init();
      }

      destroySlider() {

        if (!this.sliderInstance) {
          return;
        }

        if (this.sliderInstance.slider) {
          this.sliderInstance.slider.destroy(
            true,
            true
          );
        }

        this.sliderInstance = false;
      }

    }
  );
}